import Area, { IArea } from "./Area";
import Application from "../Application";
import { IRouter } from "../runtime/Router";
import ShowEvaluationPageInteractor from "../interactor/evaluation/ShowEvaluationPageInteractor";
import EvaluationPage from "../ui/pages/evaluation/EvaluationPage";
import { RoleConstants } from "../common/Constants";

export default class EvaluationsArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes({
      path:
        "/registered-applicants/:applicantId/details/evaluations/:evaluationId",
      page: this.createPage({
        Page: EvaluationPage,
        action: this.showEvaluationPage.bind(this)
      }),
      options: {
        secure: true,
        role: [RoleConstants.MIK_BO.MIK_OSOBLJE]
      }
    });
  }

  public showEvaluationPage(params: any) {
    return this.application.container
      .resolve<ShowEvaluationPageInteractor>("showEvaluationPage")
      .execute(params.evaluationId, params.applicantId);
  }
}
